import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid p-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mb-2 mb-xl-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-auto d-none d-sm-block" }, [
      /*#__PURE__*/_createElementVNode("h3", null, "Документы")
    ])
  ])
], -1)
const _hoisted_2 = { class: "overflow-hidden" }
const _hoisted_3 = {
  class: "bg-white position-relative overflow-auto mw-100 pb-5",
  style: {"max-height":"670px"}
}
const _hoisted_4 = { class: "table table-bordered" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-top bg-white" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "position-relative border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "# п/п"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Подтип"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Тип"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Создано"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" })
  ])
], -1)
const _hoisted_6 = { class: "py-2 px-3" }
const _hoisted_7 = { class: "py-2 px-3" }
const _hoisted_8 = { class: "py-2 px-3" }
const _hoisted_9 = { class: "py-2 px-3" }
const _hoisted_10 = { class: "py-2 px-3" }
const _hoisted_11 = { class: "btn btn-sm d-flex justify-content-center align-items-center" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", {
  class: "py-2 px-3 text-center",
  colspan: "5"
}, "Документы отсутствуют", -1)
const _hoisted_14 = [
  _hoisted_13
]

import { reactive, onMounted } from "vue";
import api from "@/api";
import { useModal } from "@/composables/useModal";
import { IDocumentSubtype } from "@/@types/IDocument";
import formatDate from "@/utils/formatDate";

type stateType = {
    documentTypes: IDocumentSubtype[],
    search: string,
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentSubTypeComponent',
  setup(__props) {


const state: stateType = reactive({
    documentTypes: [],
    search: '',
});

async function getDocumentTypes() {
    return api.document.getSubTypes().then(({ data }) => {
        state.documentTypes = data;
    });
}

onMounted(getDocumentTypes);

function handleEditDocumentType(documentType: IDocumentSubtype) {
    useModal("text_modal").open({
        title: 'Редактировать подтип документа',
        btn: 'Сохранить',
        value: documentType.name,
        label: 'Название',
        type: 'text',
    }).then((r: any) => api.document.updateSubType(documentType.id, { name: r.value }))
        .then(getDocumentTypes)
        .catch(console.error);
}

function handleDeleteDocumentType(id: number) {
    useModal('confirm_modal').open({
        question: 'Подтвердите удаление типа документа',
        ok: 'Да',
        cancel: 'Нет',
    }).then((r: any) => api.document.deleteSubType(id)).then(getDocumentTypes);
}


return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_dropdown_ui = _resolveComponent("dropdown-ui")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (state.documentTypes.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.documentTypes, (documentType, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: documentType.id
                    }, [
                      _createElementVNode("td", _hoisted_6, _toDisplayString(idx + 1), 1),
                      _createElementVNode("td", _hoisted_7, _toDisplayString(documentType.name), 1),
                      _createElementVNode("td", _hoisted_8, _toDisplayString(documentType.documentType.name), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(formatDate)(documentType.createdAt)), 1),
                      _createElementVNode("td", _hoisted_10, [
                        _createVNode(_component_dropdown_ui, null, {
                          button: _withCtx(() => [
                            _createElementVNode("button", _hoisted_11, [
                              _createVNode(_component_vue_feather, {
                                size: "14px",
                                type: "more-vertical"
                              })
                            ])
                          ]),
                          list: _withCtx(() => [
                            _createVNode(_component_button_ui, {
                              class: "dropdown-item cursor-pointer",
                              onClick: ($event: any) => (handleEditDocumentType(documentType))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Редактировать ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_button_ui, {
                              class: "dropdown-item cursor-pointer",
                              onClick: ($event: any) => (handleDeleteDocumentType(documentType.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Удалить ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_12, _hoisted_14))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})